/*
 GENERATED FILE - DO NOT MODIFY
 Any changes will be overwritten when `yarn svgs` is executed.
 
 Generated from: assets/info.svg
 If you need to make changes the attributes, modify the original .svg file.
 
 If you need to modify the file further, consider copying this generated file to a new location,
 or into the component that uses it. If you do this, it might make sense to remove the original .svg file, 
 or it could be regenerated the next time SVGs are generated.
*/
import * as React from 'react';
const InfoIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef: any) => (
    <svg
      width={47}
      height={47}
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5 47C10.521 47 0 36.479 0 23.5S10.521 0 23.5 0 47 10.521 47 23.5 36.479 47 23.5 47zm-5-34a4 4 0 118 0 4 4 0 01-8 0zm7.88 7.614c-.07-1.138-.798-2.022-1.936-2.088a16.34 16.34 0 00-.944-.026H20c-.585 0-1.075.015-1.481.037-1.187.066-1.98.941-2.01 2.13a33.341 33.341 0 000 1.667c.03 1.188.823 2.063 2.01 2.129a26.936 26.936 0 001.985.033c-.003.318-.004.652-.004 1.004v6.028c-1.27.027-2.217.068-2.912.11-1.094.067-1.972.74-2.053 1.833-.022.295-.035.636-.035 1.029 0 .394.013.734.035 1.029.08 1.092.959 1.766 2.053 1.833 1.16.07 3.022.138 5.912.138s4.753-.068 5.912-.138c1.094-.067 1.972-.74 2.053-1.834.022-.294.035-.634.035-1.028s-.013-.734-.035-1.029c-.08-1.092-.959-1.766-2.053-1.833a72.898 72.898 0 00-2.912-.11V25.5c0-2.303-.056-3.86-.12-4.886z"
        fill="currentColor"
      />
    </svg>
  ),
);
export default InfoIcon;
